import React from 'react';

import { ContentBlocksSection } from '../../components/ContentBlocksSection/ContentBlocksSection';
import { layoutHooks } from '../../hooks/layoutHooks/layoutHooks';
import { FullWidthBlocks } from '../../types/apiTypes';

export type Props = {
  items: FullWidthBlocks[];
};

export const ContentBlocksSectionContainer = (props: Props) => {
  const { items } = props;
  const { isDesktop } = layoutHooks.useDesktop();

  return (
    <ContentBlocksSection isDesktop={isDesktop} items={items} />
  );
};

ContentBlocksSectionContainer.displayName = 'ContentBlocksSectionContainer';
